import {
  CommandBarButton,
  IContextualMenuProps,
  mergeStyles,
  Persona,
  PersonaInitialsColor,
  PersonaSize
} from "@fluentui/react";
import { useAuthentication } from "global/Authentication";
import { useApplicationTheme } from "global/themes";
import React from "react";

export function UserMenu() {
  const { principal, logout } = useAuthentication();
  const { changeTheme } = useApplicationTheme();

  const rootClass = mergeStyles({ selectors: { '.ms-Button-menuIcon': { color: 'white', backgroundColor: 'transparent' } } });

  const menuProps: IContextualMenuProps = {
    items: [

      // {
      //   key: "profile",
      //   text: "Profile",
      //   iconProps: { iconName: "PlayerSettings" },
      //   onClick: () => history.push("/profile"),
      // },
      {
        key: "logout",
        text: "Logout",
        iconProps: { iconName: "SignOut" },
        onClick: () => logout("app+msal"),
      },
      {
        key: "cacheClear",
        text: "Cache Reset",
        iconProps: { iconName: "Delete" },
        onClick: async () => {
          localStorage.clear();
          sessionStorage.clear();
          {
            const keys = await window.caches.keys();
            keys.forEach(async key => {
              await window.caches.delete(key);
            });

            if (window.navigator && navigator.serviceWorker) {
              const registrations = await navigator.serviceWorker.getRegistrations()
              for (let registration of registrations) {
                await registration.unregister();
              }
            }
          }
          
          window.location.reload();
        },
      },
      {
        key: "darktheme",
        text: "Theme",
        iconProps: { iconName: "Color" },
        subMenuProps: {
          items: [

            { key: 'darktheme', text: 'Dark Mode', title: 'Dark Mode', onClick: () => changeTheme('dark') },
            { key: 'defaulttheme', text: 'Light Mode', title: 'Light Mode', onClick: () => changeTheme('default') },
          ],
        },
      },
    ],
  };

  return (
    <CommandBarButton
      menuProps={menuProps}
      className={rootClass}
      iconProps={{ iconName: "UserOptional" }}
      style={{ backgroundColor: 'transparent', color: 'white' }}
      onRenderIcon={() => {
        return (
          <Persona
            initialsColor={getInitialsTextColor(principal?.displayName)}
            initialsTextColor={'white'}
            onRenderPrimaryText={(props, defaultRender) => {
              return <></>
              // return (<div style={{ color: 'white' }}>{principal?.displayName}</div>);
            }}
            text={principal?.displayName}
            size={PersonaSize.size32}
          />
        )

        function getInitialsTextColor(displayName: string | undefined): string {
          if (!displayName) {
            return "";
          }

          // Generate a unique color based on the display name
          let hash = 0;
          for (let i = 0; i < displayName.length; i++) {
            hash = displayName.charCodeAt(i) + ((hash << 5) - hash);
          }

          // Convert the hash to a hexadecimal color code
          let color = "#";
          for (let i = 0; i < 3; i++) {
            const value = (hash >> (i * 8)) & 0xff;
            color += ("00" + value.toString(16)).substr(-2);
          }

          return color;
        }
      }}
    >
      {/* {principal?.displayName} */}
    </CommandBarButton>
  );
}